module.exports = __webpack_public_path__ + "static/media/qct-logo.dbf85671.png";